import { render, staticRenderFns } from "./prevstorage.vue?vue&type=template&id=5dbd0859&scoped=true&"
import script from "./prevstorage.vue?vue&type=script&lang=js&"
export * from "./prevstorage.vue?vue&type=script&lang=js&"
import style0 from "./prevstorage.vue?vue&type=style&index=0&id=5dbd0859&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbd0859",
  null
  
)

export default component.exports